module.exports = __webpack_public_path__ + "static/media/wf.e252fdce.webp";